@if (visible) {
  <div class="flotante-generico-container">
    <mat-card class="flotante-card">
      @if (datos?.data) {
        <mat-card-header>
          <mat-card-title>
            <div class="header-content">
              <div class="titulos">
                @switch (tipo) {
                  @case ('alarma') {
                    @if (datos?.data) {
                      <!-- ALARMA -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          doorbell
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{ datos.data?.nombre || 'Alarma' }}
                        </span>
                      </span>
                    }
                  }
                  @case ('activo') {
                    @if (datos?.data) {
                      <!-- ACTIVO -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          work
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{ datos.data?.activo?.identificacion || 'Activo' }}
                        </span>
                      </span>
                    }
                  }

                  @case ('tracker') {
                    @if (datos?.data) {
                      <!-- TRACKER -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          gps_fixed
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{
                            datos.data?.tracker?.identificacion ||
                              datos.data?.tracker?.nombre ||
                              'Tracker'
                          }}
                        </span>
                      </span>
                    }
                  }
                  @case ('gateway') {
                    @if (datos?.data) {
                      <!-- GATEWAY -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          emoji_objects
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{ datos.data?.nombre || 'Gateway' }}
                        </span>
                      </span>
                    }
                  }
                  @case ('luminaria') {
                    @if (datos?.data) {
                      <!-- LUMINARIA -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <!-- [tooltip]="datos.data?.identificacion || 'Luminaria'"
                tooltipPosition="above" -->
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          emoji_objects
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{ datos.data?.identificacion || 'Luminaria' }}
                        </span>
                      </span>
                      <!-- Botones de acción -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          gap: 4px;
                          padding-left: 8px;
                        "
                      >
                        <!-- Menú de comandos individuales (mismas restricciones que el listado) -->
                        <button
                          irxBotonIcono
                          tamano="compacto"
                          [matMenuTriggerFor]="menuLuminaria"
                          tooltip="Comandos"
                        >
                          <mat-icon>settings_remote</mat-icon>
                        </button>
                        <mat-menu #menuLuminaria="matMenu">
                          <!-- Encender -->
                          <button
                            mat-menu-item
                            [disabled]="comandoDeshabilitado"
                            (click)="
                              luminariasService.encenderLuminaria(luminaria)
                            "
                          >
                            <mat-icon color="primary">lightbulb</mat-icon>
                            <span>Encender</span>
                          </button>
                          <!-- Apagar -->
                          <button
                            mat-menu-item
                            [disabled]="comandoDeshabilitado"
                            (click)="
                              luminariasService.apagarLuminaria(luminaria)
                            "
                          >
                            <mat-icon color="primary">light_off</mat-icon>
                            <span>Apagar</span>
                          </button>

                          @if (!soloComandosManuales) {
                            <!-- Cambiar Modo -->
                            @if (!esWellness && !tienePerfilEfectivo) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.cambiarModo(luminaria)
                                "
                              >
                                <mat-icon color="primary">
                                  settings_suggest
                                </mat-icon>
                                <span>Cambiar Modo</span>
                              </button>
                            }
                            <!-- Configuración calendario -->
                            @if (
                              !esWellness && !esActis && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.configCalendario(luminaria)
                                "
                              >
                                <mat-icon color="primary">
                                  calendar_view_month
                                </mat-icon>
                                <span>Configuración Calendario</span>
                              </button>
                            }
                            <!-- Consultar Calendario (GPE) -->
                            @if (!esWellness && !esActis) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.consultarConfigCalendario(
                                    luminaria
                                  )
                                "
                              >
                                <mat-icon color="primary">
                                  manage_search
                                </mat-icon>
                                <span>Consultar Calendario</span>
                              </button>
                            }
                            <!-- Cambiar Configuración (GPE) -->
                            @if (
                              !esWellness && !esActis && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.createConfig(luminaria)
                                "
                              >
                                <mat-icon color="primary">tune</mat-icon>
                                <span>Cambiar configuración</span>
                              </button>
                            }
                            <!-- Consultar Configuración (GPE) -->
                            @if (!esWellness && !esActis) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.consultarConfig(luminaria)
                                "
                              >
                                <mat-icon color="primary">
                                  manage_search
                                </mat-icon>
                                <span>Consultar configuración</span>
                              </button>
                            }
                            <!-- Pedir GPS (GPE) -->
                            @if (!esWellness && !esActis) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="luminariasService.pedirGPS(luminaria)"
                              >
                                <mat-icon color="primary">my_location</mat-icon>
                                <span>Pedir GPS</span>
                              </button>
                            }
                            <!-- Resetear (GPE) -->
                            @if (!esWellness && !esActis) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="luminariasService.reset(luminaria)"
                              >
                                <mat-icon color="primary">
                                  power_settings_new
                                </mat-icon>
                                <span>Resetear</span>
                              </button>
                            }
                            <!-- Resetear Energía (GPE) -->
                            @if (!esWellness && !esActis) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.resetEnergia(luminaria)
                                "
                              >
                                <mat-icon color="primary">
                                  power_settings_new
                                </mat-icon>
                                <span>Resetear Energía</span>
                              </button>
                            }
                            <!-- Configuración Astronómica (ACTIS) -->
                            @if (
                              !esWellness && !esGPE && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.configActis(
                                    luminaria,
                                    'Offset'
                                  )
                                "
                              >
                                <mat-icon color="primary">wb_twilight</mat-icon>
                                <span>Configuración Astronómica</span>
                              </button>
                            }
                            <!-- Configuración Fotocélula (ACTIS) -->
                            @if (
                              !esWellness && !esGPE && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.configActis(
                                    luminaria,
                                    'Treshold'
                                  )
                                "
                              >
                                <mat-icon color="primary">wb_sunny</mat-icon>
                                <span>Configuración Fotocélula</span>
                              </button>
                            }
                            <!-- Configuración Coordenadas (ACTIS) -->
                            @if (
                              !esWellness && !esGPE && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.configActis(
                                    luminaria,
                                    'Coordinates'
                                  )
                                "
                              >
                                <mat-icon color="primary">my_location</mat-icon>
                                <span>Configuración Coordenadas</span>
                              </button>
                            }
                            <!-- Consultar Configuración (ACTIS) -->
                            @if (!esWellness && !esGPE) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.consultaActis(
                                    luminaria,
                                    'config'
                                  )
                                "
                              >
                                <mat-icon color="primary">
                                  manage_search
                                </mat-icon>
                                <span>Consultar Configuración</span>
                              </button>
                            }
                            <!-- Consultar Estado (ACTIS) -->
                            @if (!esWellness && !esGPE) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.consultaActis(
                                    luminaria,
                                    'estado'
                                  )
                                "
                              >
                                <mat-icon color="primary">
                                  manage_search
                                </mat-icon>
                                <span>Consultar Estado</span>
                              </button>
                            }
                            <!-- Consultar Configuración General (ACTIS) -->
                            @if (!esWellness && !esGPE) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.consultaActis(
                                    luminaria,
                                    'configGeneral'
                                  )
                                "
                              >
                                <mat-icon color="primary">
                                  manage_search
                                </mat-icon>
                                <span>Consultar Configuración General</span>
                              </button>
                            }
                            <!-- Configurar Reportes (ACTIS) -->
                            @if (
                              !esWellness && !esGPE && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.configActis(
                                    luminaria,
                                    'Reporte'
                                  )
                                "
                              >
                                <mat-icon color="primary">
                                  schedule_send
                                </mat-icon>
                                <span>Configurar Reportes</span>
                              </button>
                            }
                            <!-- Configurar ACKs (ACTIS) -->
                            @if (
                              !esWellness && !esGPE && !tienePerfilEfectivo
                            ) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.configActis(
                                    luminaria,
                                    'ACK'
                                  )
                                "
                              >
                                <mat-icon color="primary">verified</mat-icon>
                                <span>Configurar ACKs</span>
                              </button>
                            }
                            <!-- Consultar Configuración Dimerizado (ACTIS con dimming) -->
                            @if (dimmingDisponible) {
                              <button
                                mat-menu-item
                                [disabled]="comandoDeshabilitado"
                                (click)="
                                  luminariasService.consultarConfigDimming(
                                    luminaria
                                  )
                                "
                              >
                                <mat-icon color="primary">
                                  manage_search
                                </mat-icon>
                                <span>Consultar Configuración Dimerizado</span>
                              </button>
                            }
                          }
                        </mat-menu>
                      </div>
                    }
                  }
                  @case ('colectivo') {
                    @if (datos?.data) {
                      <!-- COLECTIVO -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          directions_car
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{ datos.data?.activo?.identificacion }}
                        </span>
                      </span>
                    }
                  }
                  @case ('vehiculo') {
                    @if (datos?.data) {
                      <!-- VEHICULO -->

                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; overflow: clip"
                        >
                          directions_car
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{
                            datos.data?.activo?.identificacion ||
                              datos.data?.activo?.vehiculo?.patente
                          }}
                        </span>
                      </span>
                    }
                  }
                  @case ('sirena') {
                    @if (datos?.data) {
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        <span
                          class="material-icons"
                          style="font-size: 16px; vertical-align: middle"
                        >
                          notification_important
                        </span>
                        <span>
                          {{
                            datos.data?.popupData?.sirena?.chipId ||
                              datos.data?.popupData?.nombre ||
                              'Sirena'
                          }}
                        </span>
                      </span>
                    }
                  }
                  @case ('emergenciaMedica') {
                    @if (datos?.data) {
                      <!-- EMERGENCIA MÉDICA -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        <span>{{ situacionEmergencia.label }}</span>
                        @if (datos?.data?.codigo) {
                          <span>#{{ datos.data.codigo }}</span>
                        }
                      </span>
                    }
                  }
                  @case ('hospital') {
                    @if (datos?.data) {
                      <!-- HOSPITAL -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        <span>
                          {{ datos?.data?.identificacion }}
                        </span>
                      </span>
                    }
                  }
                  @case ('ambulancia') {
                    @if (datos?.data) {
                      <!-- AMBULANCIA -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        <span>{{ datos?.data?.identificacion }}</span>
                      </span>
                    }
                  }
                  @case ('centroMedico') {
                    @if (datos?.data) {
                      <!-- CENTRO MEDICO -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        <span>{{ datos?.data?.identificacion }}</span>
                      </span>
                    }
                  }
                  @case ('alertaSeguridad') {
                    @if (datos?.data) {
                      <!-- ALERTA DE SEGURIDAD -->
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; color: #e53935"
                        >
                          notification_important
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          Alerta de Seguridad
                        </span>
                      </span>
                    }
                  }
                  @case ('eventoSeguridad') {
                    @if (datos?.data) {
                      <span
                        style="
                          flex: 1;
                          overflow: hidden;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <mat-icon
                          class="material-symbols-outlined"
                          style="margin-right: 4px; color: #7b1fa2"
                        >
                          event_note
                        </mat-icon>
                        <span
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            min-width: 0;
                          "
                        >
                          {{ datos?.data?.categoria || 'Evento' }}
                        </span>
                      </span>
                    }
                  }
                  @default {
                    <span>{{ titulo || 'Información' }}</span>
                  }
                }

                <!-- Botones de acción fijos en la parte superior -->
                <!-- @if (
                tipo === 'emergenciaMedica' ||
                tipo === 'hospital' ||
                tipo === 'ambulancia'
              ) { -->
                <!-- Botones de acción -->
                <!-- <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    padding-left: 8px;
                  "
                >
                  <button
                    irxBotonIcono="borde"
                    tono="primario"
                    tooltip="Editar"
                    (click)="editar()"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    irxBotonIcono="borde"
                    tono="primario"
                    tooltip="Detalles"
                    (click)="verDetalles()"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                </div>
              } -->
                <button
                  irxBotonIcono
                  tamano="compacto"
                  (click)="onCerrar()"
                  class="btn-cerrar"
                  tooltip="Cerrar"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-title>
        </mat-card-header>
      }

      <mat-card-content class="texto-contraste">
        @if (!datos?.data) {
          <div class="loading-wrapper">
            <app-loading [diameter]="32" text="Cargando datos..."></app-loading>
          </div>
        }
        @switch (tipo) {
          @case ('alarma') {
            @if (datos?.data) {
              <div class="popup">
                <!-- Botón para mostrar u ocultar información general -->
                <button
                  irxBoton="texto"
                  tamano="compacto"
                  class="popup-toggle-info"
                  (click)="mostrarInfoAlarma = !mostrarInfoAlarma"
                >
                  <mat-icon>
                    {{ mostrarInfoAlarma ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                  {{
                    mostrarInfoAlarma
                      ? 'Ocultar información'
                      : 'Ver información'
                  }}
                </button>

                <!-- Información de la alarma -->
                @if (mostrarInfoAlarma) {
                  <div class="alarma-info-section">
                    @if (datos.data.cliente?.nombre) {
                      <div class="isla-dato">
                        <div>Cliente:</div>
                        <div>
                          {{ datos.data.cliente.nombre }}
                        </div>
                      </div>
                    }

                    @if (datos.data.domicilio?.direccion) {
                      <div class="isla-dato">
                        <div>Dirección:</div>
                        <div
                          [tooltip]="
                            datos?.data?.domicilio?.direccion ||
                            datos?.data?.domicilio?.domicilio
                          "
                        >
                          {{
                            helper.extraerDireccion(
                              datos?.data?.domicilio?.direccion ||
                                datos?.data?.domicilio?.domicilio
                            )
                          }}
                        </div>
                      </div>
                    }

                    @if (
                      datos.data.modelo?.marca || datos.data.modelo?.modelo
                    ) {
                      <div class="isla-dato">
                        <div>Alarma:</div>
                        <div>
                          {{
                            datos.data.modelo?.marca &&
                            datos.data.modelo?.modelo
                              ? datos.data.modelo.marca +
                                ' - ' +
                                datos.data.modelo.modelo
                              : datos.data.modelo?.marca
                                ? datos.data.modelo.marca
                                : datos.data.modelo?.modelo
                          }}
                        </div>
                      </div>
                    }
                    @if (
                      datos.data.armado !== null &&
                      datos.data.armado !== undefined
                    ) {
                      <div class="isla-dato">
                        <div>Armada:</div>
                        <div>
                          {{ datos.data.armado ? 'Sí' : 'No' }}
                        </div>
                      </div>
                    }
                    @if (datos.data.infoZonas?.length > 0) {
                      <div class="isla-dato">
                        <div>Cantidad de zonas:</div>
                        <div>
                          {{ datos.data.infoZonas.length }}
                        </div>
                      </div>
                    }

                    @if (datos.data.sim1?.numero || datos.data.sim2?.numero) {
                      <div class="isla-dato">
                        <div>Teléfono:</div>
                        <div>
                          {{
                            datos.data.sim1?.numero && datos.data.sim2?.numero
                              ? datos.data.sim1.numero +
                                ' - ' +
                                datos.data.sim2.numero
                              : datos.data.sim1?.numero
                                ? datos.data.sim1.numero
                                : datos.data.sim2?.numero
                          }}
                        </div>
                      </div>
                    }

                    @if (ultimaComunicacionAlarma(); as ultima) {
                      <div class="isla-dato">
                        <div>Última comunicación:</div>
                        <div>
                          {{ ultima | date: 'dd/MM/yyyy HH:mm' }}
                        </div>
                      </div>
                    }

                    <!-- Chips últimos eventos -->
                    @if (datos.data?.eventosAbiertos?.length > 0) {
                      <div
                        style="
                          margin-top: 8px;
                          display: flex;
                          flex-wrap: wrap;
                          gap: 4px;
                          align-items: center;
                        "
                      >
                        @let evento = datos.data.eventosAbiertos[0];

                        <div
                          [ngStyle]="{
                            'background-color':
                              'color-mix(in srgb, ' +
                              (evento?.valores?.color || '#c62828') +
                              ' 30%, white)',
                            border:
                              '1px solid ' +
                              (evento?.valores?.color || '#c62828'),
                            color: 'black',
                          }"
                          style="
                            border-radius: 12px;
                            padding: 2px 8px;
                            font-size: 12px;
                            display: inline-flex;
                            align-items: center;
                            cursor: pointer;
                            transition: all 0.2s ease;
                          "
                          (click)="
                            $event.stopPropagation(); tratarEvento(evento)
                          "
                          (keydown.enter)="tratarEvento(evento)"
                          role="button"
                          tabindex="0"
                          tooltip="Tratar este evento"
                          tooltipPosition="below"
                          class="irx-clickeable chip-evento-clickeable"
                        >
                          <strong style="margin-right: 4px; overflow: clip">
                            Último evento:
                          </strong>
                          {{ evento?.valores?.titulo }} -
                          {{ evento?.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- Botón para mostrar u ocultar cámaras -->
                @if (tieneCamaras) {
                  <button
                    irxBoton="texto"
                    tamano="compacto"
                    class="popup-toggle-info"
                    (click)="mostrarCamarasAlarma = !mostrarCamarasAlarma"
                  >
                    <mat-icon>
                      {{ mostrarCamarasAlarma ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    {{
                      mostrarCamarasAlarma ? 'Ocultar cámaras' : 'Ver cámaras'
                    }}
                  </button>
                }

                <!-- Cámaras (colapsables) -->
                @if (tieneCamaras && mostrarCamarasAlarma) {
                  <div class="camaras-container">
                    <app-camaras-multiple
                      [data]="idsCamaras"
                      [popupMapa]="true"
                    ></app-camaras-multiple>
                  </div>
                }
                <!-- Servicios Técnicos -->
                @if (datos?.data?.eventosTecnicos?.length > 0) {
                  <mat-divider style="margin: 8px 0"></mat-divider>
                  <div class="isla-seccion-titulo">
                    <mat-icon
                      class="material-symbols-outlined"
                      style="
                        font-size: 14px;
                        width: 14px;
                        height: 14px;
                        vertical-align: middle;
                      "
                    >
                      build
                    </mat-icon>
                    Servicios técnicos
                  </div>
                  @for (ev of datos.data.eventosTecnicos; track ev._id) {
                    <div class="evento-tecnico-card">
                      <div class="evento-tecnico-header">
                        <span class="evento-tecnico-estado">
                          {{ ev.estado }}
                        </span>
                        <button
                          irxBotonIcono
                          tamano="mini"
                          class="evento-tecnico-btn"
                          tooltip="Abrir evento"
                          (click)="eventoTecnicoPopup(ev._id)"
                        >
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                      </div>
                      <div class="evento-tecnico-titulo">{{ ev.titulo }}</div>
                      @if (ev._tecnicoNombre) {
                        <div class="evento-tecnico-tecnico">
                          <mat-icon
                            class="material-symbols-outlined"
                            style="font-size: 13px; width: 13px; height: 13px"
                          >
                            engineering
                          </mat-icon>
                          {{ ev._tecnicoNombre }}
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          }
          @case ('activo') {
            @if (datos?.data) {
              <div class="popup">
                <!-- Cliente -->
                @if (datos.data.cliente?.nombre) {
                  <div class="isla-dato">
                    <div>Cliente:</div>
                    <div>
                      {{ datos.data.cliente.nombre }}
                    </div>
                  </div>
                }

                <!-- Grupo -->
                @if (datos.data.grupos) {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div>
                      {{ datos.data.grupos[0]?.nombre }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div class="no-info">Sin grupo</div>
                  </div>
                }
                <!-- Tracker-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tracker:</div>
                    <div>
                      {{ datos.data.tracker?.identificacion }}
                    </div>
                  </div>
                }

                <!-- Tipo-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tipo tracker:</div>
                    <div>
                      {{ datos.data.tracker?.tipo }}
                    </div>
                  </div>
                }

                <!-- Último Reporte / Fecha -->
                @if (datos.data.fechaCreacion) {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div>
                      {{ datos.data.fechaCreacion | date: 'short' }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div class="no-info">Sin fecha</div>
                  </div>
                }

                @let valores = datos.data.valores || {};
                <!-- Dirección -->
                @if (valores.direccion != null) {
                  <div class="isla-dato">
                    <div>Dirección:</div>
                    <div>{{ valores.direccion }}</div>
                  </div>
                }
                <!-- Velocidad -->
                @if (valores.velocidad != null) {
                  <div class="isla-dato">
                    <div>Velocidad:</div>
                    <div>{{ valores.velocidad }} km/h</div>
                  </div>
                }
                <!-- Ignición -->
                @if (valores.ignicion != null) {
                  <div class="isla-dato">
                    <div>Ignición:</div>
                    <div>{{ valores.ignicion ? 'Sí' : 'No' }}</div>
                  </div>
                }
                <!-- Odómetro -->
                @if (valores.odometro != null) {
                  <div class="isla-dato">
                    <div>Odómetro:</div>
                    <div>
                      {{ valores.odometro / 1000 | number: '1.0-1' }} km
                    </div>
                  </div>
                }
                <!-- Batería -->
                @if (valores.bateria != null) {
                  <div class="isla-dato">
                    <div>Batería:</div>
                    <div>{{ valores.bateria }}%</div>
                  </div>
                }
                <!-- Tipo de triangulación -->
                @if (valores.triangulacion != null) {
                  <div class="isla-dato">
                    <div>Triangulación:</div>
                    <div>{{ valores.triangulacion }}</div>
                  </div>
                }
              </div>
            }
          }

          @case ('tracker') {
            @if (datos?.data) {
              <div class="popup">
                <!-- Cliente -->
                @if (datos.data.cliente?.nombre) {
                  <div class="isla-dato">
                    <div>Cliente:</div>
                    <div>
                      {{ datos.data.cliente.nombre }}
                    </div>
                  </div>
                }

                <!-- Tipo-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tipo:</div>
                    <div>
                      {{ datos.data.tracker?.tipo }}
                    </div>
                  </div>
                }

                <!-- Grupo -->
                @if (datos.data.grupos) {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div>
                      {{ datos.data.grupos[0]?.nombre }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div class="no-info">Sin grupo</div>
                  </div>
                }

                <!-- Último Reporte / Fecha -->
                @if (datos.data.fechaCreacion) {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div>
                      {{ datos.data.fechaCreacion | date: 'short' }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div class="no-info">Sin fecha</div>
                  </div>
                }

                @let valores = datos.data.valores || {};
                <!-- Dirección -->
                @if (valores.direccion != null) {
                  <div class="isla-dato">
                    <div>Dirección:</div>
                    <div>{{ valores.direccion }}</div>
                  </div>
                }
                <!-- Velocidad -->
                @if (valores.velocidad != null) {
                  <div class="isla-dato">
                    <div>Velocidad:</div>
                    <div>{{ valores.velocidad }} km/h</div>
                  </div>
                }
                <!-- Ignición -->
                @if (valores.ignicion != null) {
                  <div class="isla-dato">
                    <div>Ignición:</div>
                    <div>{{ valores.ignicion ? 'Sí' : 'No' }}</div>
                  </div>
                }
                <!-- Odómetro -->
                @if (valores.odometro != null) {
                  <div class="isla-dato">
                    <div>Odómetro:</div>
                    <div>
                      {{ valores.odometro / 1000 | number: '1.0-1' }} km
                    </div>
                  </div>
                }
                <!-- Batería -->
                @if (valores.bateria != null) {
                  <div class="isla-dato">
                    <div>Batería:</div>
                    <div>{{ valores.bateria }}%</div>
                  </div>
                }
                <!-- Tipo de triangulación -->
                @if (valores.triangulacion != null) {
                  <div class="isla-dato">
                    <div>Triangulación:</div>
                    <div>{{ valores.triangulacion }}</div>
                  </div>
                }
              </div>
            }
          }
          @case ('luminaria') {
            @if (luminaria) {
              <!-- Popup DETALLADO -->
              <div class="popup">
                <!-- Cliente -->
                <div class="isla-dato">
                  <div>Cliente:</div>
                  @if (luminaria.cliente?.nombre) {
                    <div>{{ luminaria.cliente.nombre }}</div>
                  } @else {
                    <div class="no-info">Sin cliente</div>
                  }
                </div>
                @let turnOnOff = getTurnOnOffCalculado;

                <div class="isla-dato">
                  <div>Encendido:</div>
                  <div>
                    {{
                      turnOnOff === true
                        ? 'Sí'
                        : turnOnOff === false
                          ? 'No'
                          : 'Indeterminado'
                    }}
                  </div>
                </div>
                @let estado = getEstado;
                @let config = luminaria.dispositivo?.config;
                <!-- mas cosas del estado -->
                <div class="isla-dato">
                  <div>Estado:</div>
                  @if (estado?.ultimoEstado) {
                    <div>{{ estado?.ultimoEstado }}</div>
                  } @else {
                    <div class="no-info">Sin estado</div>
                  }
                </div>

                @let modo =
                  $any(config)?.mode ||
                  luminaria?.ultimoReportePeriodico?.valores?.['modo'];
                <div class="isla-dato">
                  <div>Modo:</div>
                  @if (modo) {
                    <div>{{ modo }}</div>
                  } @else {
                    <div class="no-info">Sin modo</div>
                  }
                </div>

                @let potencia =
                  $any(config)?.potencia ??
                  luminaria?.ultimoReporteEnergia?.valores?.['potencia'];
                @if (potencia != null) {
                  <div class="isla-dato">
                    <div>Potencia:</div>
                    <div>{{ potencia | number: '1.0-2' }} W</div>
                  </div>
                }
                @if ($any(config)?.energiaTotal != null) {
                  <div class="isla-dato">
                    <div>Consumo acumulado:</div>
                    <div>
                      {{ $any(config)?.energiaTotal | number: '1.0-2' }} kWh
                    </div>
                  </div>
                }
                @let voltaje =
                  $any(config)?.voltaje ??
                  luminaria?.ultimoReporteEnergia?.valores?.['voltaje'];
                @if (voltaje != null) {
                  <div class="isla-dato">
                    <div>Voltaje:</div>
                    <div>{{ voltaje | number: '1.0-2' }} V</div>
                  </div>
                }
                @let factorPotencia =
                  luminaria?.ultimoReporteEnergia?.valores?.['factorPotencia'];
                @if (factorPotencia != null) {
                  <div class="isla-dato">
                    <div>Factor de potencia:</div>
                    <div>{{ factorPotencia | number: '1.0-2' }}</div>
                  </div>
                }
                @let corriente =
                  luminaria?.ultimoReporteEnergia?.valores?.['corriente'];
                @if (corriente != null) {
                  <div class="isla-dato">
                    <div>Corriente:</div>
                    <div>{{ corriente | number: '1.0-2' }} A</div>
                  </div>
                }
                @let dimming =
                  luminaria?.ultimoReportePeriodico?.valores?.['dimmingValue'];
                @if (dimming != null) {
                  <div class="isla-dato">
                    <div>Dimming:</div>
                    <div>{{ dimming | number: '1.0-0' }} %</div>
                  </div>
                }

                <!-- Fecha Creación -->
                @if (luminaria.fechaCreacion) {
                  <div class="isla-dato">
                    <div>Creación:</div>
                    <div>
                      {{ luminaria.fechaCreacion | date: 'short' }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Creación:</div>
                    <div class="no-info">Sin fecha</div>
                  </div>
                }

                <!-- Ultima comunicación -->
                @let comunicacion = comunicacionCalculada;
                <div class="isla-dato">
                  <div>Última comunicación:</div>
                  @if (comunicacion?.fecha) {
                    <div class="valor-con-punto">
                      <span
                        class="punto-estado"
                        [style.background-color]="comunicacion.color"
                      ></span>
                      {{ comunicacion.fecha }}
                    </div>
                  } @else {
                    <div class="no-info">Sin comunicación</div>
                  }
                </div>

                @let frecuencia = frecReporteTexto(luminaria);
                <div class="isla-dato">
                  <div>Frecuencia de reporte:</div>
                  @if (frecuencia) {
                    <div>{{ frecuencia }} min</div>
                  } @else {
                    <div class="no-info">Sin frecuencia de reporte</div>
                  }
                </div>

                @if (luminaria.direccion) {
                  <div class="isla-dato">
                    <!-- Etiqueta -->
                    <div style="white-space: nowrap">Dirección:</div>

                    <!-- Valor de la dirección -->
                    <div
                      style="
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: right;
                      "
                      [tooltip]="luminaria.direccion"
                    >
                      {{ helper.extraerDireccion(luminaria.direccion) }}
                    </div>
                  </div>
                }
                <!-- Alarmas como chips -->
                @if (alarmas.length > 0) {
                  <div
                    style="
                      margin-top: 8px;
                      display: flex;
                      flex-wrap: wrap;
                      gap: 4px;
                    "
                  >
                    @for (alarma of alarmas; track alarma) {
                      <div
                        style="
                          background-color: #ffebee;
                          color: #c62828;
                          border: 1px solid #c62828;
                          border-radius: 12px;
                          padding: 2px 8px;
                          font-size: 12px;
                          display: inline-flex;
                          align-items: center;
                        "
                      >
                        {{ alarma }}
                      </div>
                    }
                  </div>
                }
                <!-- Perfil efectivo (computado en backend) -->
                <div class="isla-dato">
                  <div>Perfil efectivo:</div>
                  @if (perfilEfectivo) {
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                        align-items: flex-end;
                      "
                    >
                      <span style="font-weight: 500">
                        {{ perfilEfectivo.nombre || 'Sin nombre' }}
                      </span>
                      <span
                        style="
                          display: inline-flex;
                          align-items: center;
                          gap: 4px;
                          font-size: 11px;
                          padding: 1px 6px;
                          border-radius: 8px;
                          background: var(--theme-primary-500, #1976d2);
                          color: #fff;
                          width: fit-content;
                        "
                      >
                        <span
                          class="material-symbols-outlined"
                          style="font-size: 14px"
                        >
                          {{ nivelMeta(perfilEfectivo.nivel).icon }}
                        </span>
                        <span>{{ nivelMeta(perfilEfectivo.nivel).label }}</span>
                      </span>
                      @if (
                        perfilEfectivo.nivel !== 'luminaria' &&
                        perfilEfectivo.nombreFuente
                      ) {
                        <span style="font-size: 11px; opacity: 0.8">
                          {{ perfilEfectivo.nombreFuente }}
                        </span>
                      }
                    </div>
                  } @else {
                    <div class="no-info">Sin perfil</div>
                  }
                </div>

                <!-- Asignaciones (contenedores a los que pertenece) -->
                <div class="isla-dato">
                  <div>Asignaciones:</div>
                  @if (asignaciones.length) {
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                        align-items: flex-end;
                      "
                    >
                      @for (a of asignaciones; track a) {
                        <span
                          style="
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            font-size: 12px;
                          "
                          [tooltip]="nivelMeta(a.nivel).label"
                        >
                          <span
                            class="material-symbols-outlined"
                            style="font-size: 16px; opacity: 0.7"
                          >
                            {{ nivelMeta(a.nivel).icon }}
                          </span>
                          <span>{{ a.nombre || 'Sin nombre' }}</span>
                        </span>
                      }
                    </div>
                  } @else {
                    <div class="no-info">Sin asignaciones</div>
                  }
                </div>
              </div>
            }
          }
          @case ('gateway') {
            @if (datos?.data) {
              <div class="popup">
                <!-- Nombre -->
                @if (datos?.data?.nombre) {
                  <div class="isla-dato">
                    <div>Identificación:</div>
                    <div>{{ datos?.data?.nombre }}</div>
                  </div>
                }

                @if (datos?.data?.nombreChirpstack) {
                  <div class="isla-dato">
                    <div>Nombre en Chirpstack:</div>
                    <div>
                      {{ datos?.data?.nombreChirpstack }}
                    </div>
                  </div>
                }

                <!-- Cliente -->
                @if (datos?.data?.cliente?.nombre) {
                  <div class="isla-dato">
                    <div>Cliente:</div>
                    <div>
                      {{ datos?.data?.cliente.nombre }}
                    </div>
                  </div>
                }

                <!-- Fecha Creación -->
                @if (datos?.data?.fechaCreacion) {
                  <div class="isla-dato">
                    <div>Creación:</div>
                    <div>
                      {{ datos?.data?.fechaCreacion | date: 'short' }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Creación:</div>
                    <div class="no-info">Sin fecha</div>
                  </div>
                }

                <!-- ToA Promedio -->
                @if (datos?.data?.toaPromedioHora != null) {
                  <div class="isla-dato">
                    <div>ToA Promedio:</div>
                    <div>{{ datos?.data?.toaPromedioHora | number }} ms</div>
                  </div>
                }

                <!-- Estado de Salud -->
                @if (datos?.data?.estadoSalud) {
                  <div class="isla-dato">
                    <div>Estado:</div>
                    <div
                      [ngStyle]="{
                        color:
                          datos?.data?.estadoSalud === 'ok'
                            ? '#4CAF50'
                            : datos?.data?.estadoSalud === 'warning'
                              ? '#FFA000'
                              : '#D32F2F',
                        'font-weight': 'bold',
                      }"
                    >
                      {{
                        datos?.data?.estadoSalud === 'ok'
                          ? 'Óptimo'
                          : datos?.data?.estadoSalud === 'warning'
                            ? 'Moderado'
                            : 'Alto'
                      }}
                    </div>
                  </div>
                }
                <!-- Servicios Técnicos -->
                @if (datos?.data?.eventosTecnicos?.length > 0) {
                  <mat-divider style="margin: 8px 0"></mat-divider>
                  <div class="isla-seccion-titulo">
                    <mat-icon
                      class="material-symbols-outlined"
                      style="
                        font-size: 14px;
                        width: 14px;
                        height: 14px;
                        vertical-align: middle;
                      "
                    >
                      build
                    </mat-icon>
                    Servicios técnicos
                  </div>
                  @for (ev of datos.data.eventosTecnicos; track ev._id) {
                    <div class="evento-tecnico-card">
                      <div class="evento-tecnico-header">
                        <span class="evento-tecnico-estado">
                          {{ ev.estado }}
                        </span>
                        <button
                          irxBotonIcono
                          tamano="mini"
                          class="evento-tecnico-btn"
                          tooltip="Abrir evento"
                          (click)="eventoTecnicoPopup(ev._id)"
                        >
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                      </div>
                      <div class="evento-tecnico-titulo">{{ ev.titulo }}</div>
                      @if (ev._tecnicoNombre) {
                        <div class="evento-tecnico-tecnico">
                          <mat-icon
                            class="material-symbols-outlined"
                            style="font-size: 13px; width: 13px; height: 13px"
                          >
                            engineering
                          </mat-icon>
                          {{ ev._tecnicoNombre }}
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          }
          @case ('colectivo') {
            @if (datos?.data) {
              <!-- Cliente -->
              @if (datos.data.cliente?.nombre) {
                <div class="isla-dato">
                  <div>Cliente:</div>
                  <div>
                    {{ datos.data.cliente.nombre }}
                  </div>
                </div>
              }
              @let reporte = datos.data;
              @if (reporte?.activo?.vehiculo) {
                <!-- Grupo -->
                @if (reporte?.grupos) {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div>
                      {{ reporte?.grupos?.[0]?.nombre }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div class="no-info">Línea no asignada</div>
                  </div>
                }

                <!-- Tracker-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tracker:</div>
                    <div>
                      {{ datos.data.tracker?.identificacion }}
                    </div>
                  </div>
                }

                <!-- Tipo-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tipo tracker:</div>
                    <div>
                      {{ datos.data.tracker?.tipo }}
                    </div>
                  </div>
                }
                <!-- Recorrido -->
                @if (reporte?.activo?.vehiculo?.recorridos) {
                  <div class="isla-dato">
                    <div>Recorrido:</div>
                    <div>
                      {{ reporte.activo.vehiculo.recorridos[0]?.nombre }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Recorrido:</div>
                    <div class="no-info">Sin recorrido asignado</div>
                  </div>
                }

                <!-- Fecha  -->
                @if (reporte?.fechaCreacion) {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div>
                      {{ reporte?.fechaCreacion | date: 'short' }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div class="no-info">Sin reportar</div>
                  </div>
                }

                @let valores = datos.data.valores || {};
                <!-- Dirección -->
                @if (valores.direccion != null) {
                  <div class="isla-dato">
                    <div>Dirección:</div>
                    <div>{{ valores.direccion }}</div>
                  </div>
                }
                <!-- Velocidad -->
                @if (valores.velocidad != null) {
                  <div class="isla-dato">
                    <div>Velocidad:</div>
                    <div>{{ valores.velocidad }} km/h</div>
                  </div>
                }
                <!-- Ignición -->
                @if (valores.ignicion != null) {
                  <div class="isla-dato">
                    <div>Ignición:</div>
                    <div>{{ valores.ignicion ? 'Sí' : 'No' }}</div>
                  </div>
                }
                <!-- Odómetro -->
                @if (valores.odometro != null) {
                  <div class="isla-dato">
                    <div>Odómetro:</div>
                    <div>
                      {{ valores.odometro / 1000 | number: '1.0-1' }} km
                    </div>
                  </div>
                }
                <!-- Batería -->
                @if (valores.bateria != null) {
                  <div class="isla-dato">
                    <div>Batería:</div>
                    <div>{{ valores.bateria }}%</div>
                  </div>
                }
                <!-- Tipo de triangulación -->
                @if (valores.triangulacion != null) {
                  <div class="isla-dato">
                    <div>Triangulación:</div>
                    <div>{{ valores.triangulacion }}</div>
                  </div>
                }
              }
            }
          }
          @case ('vehiculo') {
            @if (datos?.data) {
              <!-- Cliente -->
              @if (datos.data.cliente?.nombre) {
                <div class="isla-dato">
                  <div>Cliente:</div>
                  <div>
                    {{ datos.data.cliente.nombre }}
                  </div>
                </div>
              }
              @let reporte = datos.data;
              @if (reporte?.activo?.vehiculo) {
                <!-- Grupo -->
                @if (reporte?.grupos?.[0]?.nombre) {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div>
                      {{ reporte?.grupos?.[0]?.nombre }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Grupo:</div>
                    <div class="no-info">Sin grupo asignado</div>
                  </div>
                }

                <!-- Patente -->
                @if (reporte?.activo?.vehiculo?.patente) {
                  <div class="isla-dato">
                    <div>Patente:</div>
                    <div>
                      {{ reporte?.activo?.vehiculo?.patente }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Patente:</div>
                    <div class="no-info">Sin patente</div>
                  </div>
                }
                <!-- Tipo -->
                @if (reporte?.activo?.vehiculo?.tipo) {
                  <div class="isla-dato">
                    <div>Tipo:</div>
                    <div>
                      {{ reporte?.activo?.vehiculo?.tipo }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Tipo:</div>
                    <div class="no-info">Sin tipo</div>
                  </div>
                }

                <!-- Combustible -->
                @let combCap = reporte?.activo?.vehiculo?.capacidadCombustible;
                @let combNivel =
                  datos.data.valores?.nivelCombustibleTotal ??
                  datos.data.valores?.nivelPostVariacion;
                @if (combCap || combNivel != null) {
                  <div class="isla-dato">
                    <div>Combustible:</div>
                    <div>
                      @if (combNivel != null && combCap) {
                        {{ combNivel }} / {{ combCap }} L ({{
                          (combNivel / combCap) * 100 | number: '1.0-0'
                        }}%)
                      } @else if (combCap) {
                        {{ combCap }} L
                      } @else {
                        {{ combNivel }} L
                      }
                    </div>
                  </div>
                }

                <!-- Tracker-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tracker:</div>
                    <div>
                      {{ datos.data.tracker?.identificacion }}
                    </div>
                  </div>
                }

                <!-- Tipo-->
                @if (datos.data.tracker) {
                  <div class="isla-dato">
                    <div>Tipo tracker:</div>
                    <div>
                      {{ datos.data.tracker?.tipo }}
                    </div>
                  </div>
                }

                <!-- Fecha  -->
                @if (reporte?.fechaCreacion) {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div>
                      {{ reporte?.fechaCreacion | date: 'short' }}
                    </div>
                  </div>
                } @else {
                  <div class="isla-dato">
                    <div>Último reporte:</div>
                    <div class="no-info">Sin reportar</div>
                  </div>
                }

                @let valores = datos.data.valores || {};
                <!-- Dirección -->
                @if (valores.direccion != null) {
                  <div class="isla-dato">
                    <div>Dirección:</div>
                    <div>{{ valores.direccion }}</div>
                  </div>
                }
                <!-- Velocidad -->
                @if (valores.velocidad != null) {
                  <div class="isla-dato">
                    <div>Velocidad:</div>
                    <div>{{ valores.velocidad }} km/h</div>
                  </div>
                }
                <!-- Ignición -->
                @if (valores.ignicion != null) {
                  <div class="isla-dato">
                    <div>Ignición:</div>
                    <div>{{ valores.ignicion ? 'Sí' : 'No' }}</div>
                  </div>
                }
                <!-- Odómetro -->
                @if (valores.odometro != null) {
                  <div class="isla-dato">
                    <div>Odómetro:</div>
                    <div>
                      {{ valores.odometro / 1000 | number: '1.0-1' }} km
                    </div>
                  </div>
                }
                <!-- Batería -->
                @if (valores.bateria != null) {
                  <div class="isla-dato">
                    <div>Batería:</div>
                    <div>{{ valores.bateria }}%</div>
                  </div>
                }
                <!-- Tipo de triangulación -->
                @if (valores.triangulacion != null) {
                  <div class="isla-dato">
                    <div>Triangulación:</div>
                    <div>{{ valores.triangulacion }}</div>
                  </div>
                }
              }
            }
          }
          @case ('sirena') {
            @if (datos?.data) {
              <div class="popup">
                <div class="alarma-info-section">
                  @if (datos?.data?.popupData?.nombre) {
                    <div class="isla-dato">
                      <div>Nombre:</div>
                      <div>{{ datos?.data?.popupData?.nombre }}</div>
                    </div>
                  }

                  @if (datos?.data?.popupData?.sirena?.chipId) {
                    <div class="isla-dato">
                      <div>Chip ID:</div>
                      <div>
                        {{ datos?.data?.popupData?.sirena?.chipId }}
                      </div>
                    </div>
                  }

                  @if (datos?.data?.popupData?.idExterno) {
                    <div class="isla-dato">
                      <div>ID Externo:</div>
                      <div>
                        {{ datos?.data?.popupData?.idExterno }}
                      </div>
                    </div>
                  }

                  @if (datos?.data?.popupData?.sirena) {
                    @let estado =
                      sirenasService.devolverEstado(
                        datos?.data?.popupData?.sirena
                      );
                    <div class="isla-dato">
                      <div>Estado:</div>
                      <div
                        [style.color]="sirenasService.getColorEstado(estado)"
                        style="font-weight: 600"
                      >
                        <span
                          class="material-icons"
                          style="font-size: 14px; vertical-align: middle"
                        >
                          {{ sirenasService.getIconoEstado(estado) }}
                        </span>
                        {{ estado }}
                      </div>
                    </div>
                  }

                  @if (conectividadSirena != null) {
                    <div class="isla-dato">
                      <div>Conectada:</div>
                      <div>
                        @if (conectividadSirena) {
                          <div style="color: #4caf50">
                            <span
                              class="material-icons"
                              style="font-size: 14px; vertical-align: middle"
                            >
                              check_circle
                            </span>
                            En línea
                          </div>
                        } @else {
                          <div style="color: #f44336">
                            <span
                              class="material-icons"
                              style="font-size: 14px; vertical-align: middle"
                            >
                              cancel
                            </span>
                            Desconectada
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (datos?.data?.popupData?.sirena?.versionFirmware) {
                    <div class="isla-dato">
                      <div>Firmware:</div>
                      <div>
                        {{ datos?.data?.popupData?.sirena?.versionFirmware }}
                      </div>
                    </div>
                  }

                  @if (fechaComunicacionSirena) {
                    <div class="isla-dato">
                      <div>Última comunicación:</div>
                      <div>
                        {{ fechaComunicacionSirena | date: 'dd/MM/yyyy HH:mm' }}
                      </div>
                    </div>
                  }

                  @if (datos?.data?.popupData?.sirena?.direccionGps) {
                    <div class="isla-dato">
                      <div style="white-space: nowrap">Dirección:</div>
                      <div
                        style="
                          flex: 1;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                        [tooltip]="datos?.data?.popupData?.sirena?.direccionGps"
                      >
                        {{ datos?.data?.popupData?.sirena?.direccionGps }}
                      </div>
                    </div>
                  }

                  @if (datos?.data?.cliente?.nombre) {
                    <div class="isla-dato">
                      <div>Cliente:</div>
                      <div>
                        {{ datos?.data?.cliente?.nombre }}
                      </div>
                    </div>
                  }
                </div>

                <!-- Cámaras (siempre visibles si existen) -->
                @if (tieneCamarasSirena) {
                  <div class="camaras-container">
                    <app-camaras-multiple
                      [data]="idsAsignados"
                      [popupMapa]="true"
                    ></app-camaras-multiple>
                  </div>
                }
                <!-- Servicios Técnicos -->
                @if (datos?.data?.eventosTecnicos?.length > 0) {
                  <mat-divider style="margin: 8px 0"></mat-divider>
                  <div class="isla-seccion-titulo">
                    <mat-icon
                      class="material-symbols-outlined"
                      style="
                        font-size: 14px;
                        width: 14px;
                        height: 14px;
                        vertical-align: middle;
                      "
                    >
                      build
                    </mat-icon>
                    Servicios técnicos
                  </div>
                  @for (ev of datos.data.eventosTecnicos; track ev._id) {
                    <div class="evento-tecnico-card">
                      <div class="evento-tecnico-header">
                        <span class="evento-tecnico-estado">
                          {{ ev.estado }}
                        </span>
                        <button
                          irxBotonIcono
                          tamano="mini"
                          class="evento-tecnico-btn"
                          tooltip="Abrir evento"
                          (click)="eventoTecnicoPopup(ev._id)"
                        >
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                      </div>
                      <div class="evento-tecnico-titulo">{{ ev.titulo }}</div>
                      @if (ev._tecnicoNombre) {
                        <div class="evento-tecnico-tecnico">
                          <mat-icon
                            class="material-symbols-outlined"
                            style="font-size: 13px; width: 13px; height: 13px"
                          >
                            engineering
                          </mat-icon>
                          {{ ev._tecnicoNombre }}
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          }
          @case ('emergenciaMedica') {
            @if (datos?.data) {
              <div class="isla-dato">
                <div>Estado:</div>
                <div>
                  <span
                    class="emergencia-badge"
                    [style.color]="estadoEmergencia.color"
                    [style.background]="
                      'color-mix(in srgb, ' +
                      estadoEmergencia.color +
                      ' 16%, transparent)'
                    "
                  >
                    <span class="material-icons">
                      {{ estadoEmergencia.icono }}
                    </span>
                    {{ estadoEmergencia.label }}
                  </span>
                </div>
              </div>
              <div class="isla-dato">
                <div>Código:</div>
                <div>
                  @if (prioridadEmergencia; as prioridad) {
                    <span
                      class="emergencia-badge"
                      [style.color]="prioridad.color"
                      [style.background]="
                        'color-mix(in srgb, ' +
                        prioridad.color +
                        ' 16%, transparent)'
                      "
                    >
                      <span class="material-icons">{{ prioridad.icono }}</span>
                      {{ prioridad.label }}
                    </span>
                  } @else {
                    <span class="no-info">Sin código</span>
                  }
                </div>
              </div>
              <div class="isla-dato">
                <div>Móvil:</div>
                @if (movilEmergencia) {
                  <div>{{ movilEmergencia }}</div>
                } @else {
                  <div class="no-info">Sin móvil asignado</div>
                }
              </div>
              <div class="isla-dato">
                <div>Dirección:</div>
                @if (datos?.data?.direccion) {
                  <div [tooltip]="datos.data.direccion">
                    {{ datos.data.direccion }}
                  </div>
                } @else {
                  <div class="no-info">Sin dirección</div>
                }
              </div>
              <div class="isla-dato">
                <div>Creación:</div>
                @if (datos?.data?.fechaCreacion) {
                  <div>
                    {{ datos.data.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                } @else {
                  <div class="no-info">Sin fecha</div>
                }
              </div>
              <div class="isla-dato">
                <div>Última actualización:</div>
                @if (datos?.data?.ultimaActualizacion) {
                  <div>
                    {{
                      datos.data.ultimaActualizacion | date: 'dd/MM/yyyy HH:mm'
                    }}
                  </div>
                } @else {
                  <div class="no-info">Sin actualizaciones</div>
                }
              </div>
              <div class="isla-dato">
                <div>Solicitante:</div>
                @if (datos?.data?.solicitante || datos?.data?.telefono) {
                  <div>
                    {{ datos?.data?.solicitante || 'Sin nombre' }}
                    @if (datos?.data?.telefono) {
                      <span>· Tel. {{ datos.data.telefono }}</span>
                    }
                  </div>
                } @else {
                  <div class="no-info">Sin solicitante</div>
                }
              </div>
              @let paciente = datos?.data?.destinatarioAsistencia;
              <div class="isla-dato">
                <div>Paciente:</div>
                @if (paciente?.nombre) {
                  <div>
                    {{ paciente.nombre }}
                    @if (paciente.dni) {
                      <span>· DNI {{ paciente.dni }}</span>
                    }
                    @if (paciente.sexo) {
                      <span>· Sexo {{ paciente.sexo }}</span>
                    }
                  </div>
                } @else {
                  <div class="no-info">Sin paciente</div>
                }
              </div>
              <div class="isla-dato">
                <div>Teléfono del paciente:</div>
                @if (paciente?.telefono) {
                  <div>{{ paciente.telefono }}</div>
                } @else {
                  <div class="no-info">Sin teléfono</div>
                }
              </div>
              <div class="isla-dato">
                <div>Obra social:</div>
                @if (paciente?.obraSocial) {
                  <div>{{ paciente.obraSocial }}</div>
                } @else {
                  <div class="no-info">Sin obra social</div>
                }
              </div>
              <div class="isla-dato">
                <div>Síntomas:</div>
                @if (sintomasEmergencia.length) {
                  <div [tooltip]="sintomasEmergencia.join(', ')">
                    {{ sintomasEmergencia.join(', ') }}
                  </div>
                } @else {
                  <div class="no-info">Sin síntomas</div>
                }
              </div>
            }
          }
          @case ('hospital') {
            @if (datos?.data) {
              <div class="isla-dato">
                <div style="white-space: nowrap">Dirección:</div>
                @if (datos?.data?.direccion) {
                  <div [tooltip]="datos.data.direccion">
                    {{ datos.data.direccion }}
                  </div>
                } @else {
                  <div class="no-info">Sin dirección</div>
                }
              </div>
              <div class="isla-dato">
                <div>Teléfono:</div>
                @if (datos?.data?.valores?.telefono) {
                  <div>{{ datos.data.valores.telefono }}</div>
                } @else {
                  <div class="no-info">Sin teléfono</div>
                }
              </div>
              <div class="isla-dato">
                <div>Activo:</div>
                <div>{{ datos?.data?.valores?.activo ? 'Sí' : 'No' }}</div>
              </div>
              <div class="isla-dato">
                <div>Email:</div>
                @if (datos?.data?.valores?.email) {
                  <div>{{ datos.data.valores.email }}</div>
                } @else {
                  <div class="no-info">Sin email</div>
                }
              </div>
              <div class="isla-dato">
                <div>Gestión:</div>
                @if (datos?.data?.valores?.gestion) {
                  <div>{{ datos.data.valores.gestion }}</div>
                } @else {
                  <div class="no-info">Sin gestión</div>
                }
              </div>
              <div class="isla-dato">
                <div>Fecha de creación:</div>
                @if (datos?.data?.fechaCreacion) {
                  <div>
                    {{ datos.data.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                } @else {
                  <div class="no-info">Sin fecha</div>
                }
              </div>
            }
          }
          @case ('ambulancia') {
            @if (datos?.data) {
              <!-- Grupo -->
              @if (datos?.data?.grupo?.nombre) {
                <div class="isla-dato">
                  <div>Grupo:</div>
                  <div>
                    {{ datos?.data?.grupo?.nombre }}
                  </div>
                </div>
              } @else {
                <div class="isla-dato">
                  <div>Grupo:</div>
                  <div class="no-info">Sin grupo asignado</div>
                </div>
              }

              <!-- Patente -->
              @if (datos?.data?.vehiculo?.patente) {
                <div class="isla-dato">
                  <div>Patente:</div>
                  <div>
                    {{ datos?.data?.vehiculo?.patente }}
                  </div>
                </div>
              } @else {
                <div class="isla-dato">
                  <div>Patente:</div>
                  <div class="no-info">Sin patente</div>
                </div>
              }

              <!-- Combustible -->
              @let combCap = datos?.data?.vehiculo?.capacidadCombustible;
              @let combNivel =
                datos?.data?.ultimoReporte?.valores?.nivelCombustibleTotal;
              @if (combCap || combNivel != null) {
                <div class="isla-dato">
                  <div>Combustible:</div>
                  <div>
                    @if (combNivel != null && combCap) {
                      {{ combNivel }} / {{ combCap }} L ({{
                        (combNivel / combCap) * 100 | number: '1.0-0'
                      }}%)
                    } @else if (combCap) {
                      {{ combCap }} L
                    } @else {
                      {{ combNivel }} L
                    }
                  </div>
                </div>
              }

              @let tracker = datos?.data?.tracker;
              <!-- Tracker-->
              @if (tracker) {
                <div class="isla-dato">
                  <div>Tracker:</div>
                  <div>
                    {{ tracker?.nombre }}
                  </div>
                </div>
              }

              <!-- Tipo-->
              @if (tracker) {
                <div class="isla-dato">
                  <div>Tipo tracker:</div>
                  <div>
                    {{ tracker.tipo }}
                  </div>
                </div>
              }

              @let reporte = datos.data?.ultimoReporte;
              <!-- Fecha  -->
              @if (reporte?.fechaCreacion) {
                <div class="isla-dato">
                  <div>Último reporte:</div>
                  <div>
                    {{ reporte?.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                </div>
              } @else {
                <div class="isla-dato">
                  <div>Último reporte:</div>
                  <div class="no-info">Sin reportar</div>
                </div>
              }

              @let valores = datos.data?.ultimoReporte?.valores || {};
              <!-- Dirección -->
              @if (valores.direccion != null) {
                <div class="isla-dato">
                  <div>Dirección:</div>
                  <div>{{ valores.direccion }}</div>
                </div>
              }
              <!-- Velocidad -->
              @if (valores.velocidad != null) {
                <div class="isla-dato">
                  <div>Velocidad:</div>
                  <div>{{ valores.velocidad }} km/h</div>
                </div>
              }
              <!-- Ignición -->
              @if (valores.ignicion != null) {
                <div class="isla-dato">
                  <div>Ignición:</div>
                  <div>{{ valores.ignicion ? 'Sí' : 'No' }}</div>
                </div>
              }
              <!-- Odómetro -->
              @if (valores.odometro != null) {
                <div class="isla-dato">
                  <div>Odómetro:</div>
                  <div>{{ valores.odometro / 1000 | number: '1.0-1' }} km</div>
                </div>
              }
              <!-- Batería -->
              @if (valores.bateria != null) {
                <div class="isla-dato">
                  <div>Batería:</div>
                  <div>{{ valores.bateria }}%</div>
                </div>
              }
              <!-- Tipo de triangulación -->
              @if (valores.triangulacion != null) {
                <div class="isla-dato">
                  <div>Triangulación:</div>
                  <div>{{ valores.triangulacion }}</div>
                </div>
              }
            }
          }
          @case ('centroMedico') {
            @if (datos?.data) {
              <div class="isla-dato">
                <div>Dirección:</div>
                @if (datos?.data?.direccion) {
                  <div [tooltip]="datos.data.direccion">
                    {{ datos.data.direccion }}
                  </div>
                } @else {
                  <div class="no-info">Sin dirección</div>
                }
              </div>
              <div class="isla-dato">
                <div>Teléfono:</div>
                @if (datos?.data?.valores?.telefono) {
                  <div>{{ datos.data.valores.telefono }}</div>
                } @else {
                  <div class="no-info">Sin teléfono</div>
                }
              </div>
              <div class="isla-dato">
                <div>Activo:</div>
                <div>{{ datos?.data?.valores?.activo ? 'Sí' : 'No' }}</div>
              </div>
              <div class="isla-dato">
                <div>Email:</div>
                @if (datos?.data?.valores?.email) {
                  <div>{{ datos.data.valores.email }}</div>
                } @else {
                  <div class="no-info">Sin email</div>
                }
              </div>
              <div class="isla-dato">
                <div>Fecha de creación:</div>
                @if (datos?.data?.fechaCreacion) {
                  <div>
                    {{ datos.data.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                } @else {
                  <div class="no-info">Sin fecha</div>
                }
              </div>
            }
          }
          @case ('eventoSeguridad') {
            @if (datos?.data) {
              @if (datos?.data?.categoria) {
                <div class="isla-dato">
                  <div>Categoría:</div>
                  <div>{{ datos?.data?.categoria }}</div>
                </div>
              }
              @if (datos?.data?.fecha) {
                <div class="isla-dato">
                  <div>Fecha:</div>
                  <div>{{ datos?.data?.fecha | date: 'dd/MM/yyyy HH:mm' }}</div>
                </div>
              }
              @if (datos?.data?.emisor) {
                <div class="isla-dato">
                  <div>Emisor:</div>
                  <div>{{ datos?.data?.emisor }}</div>
                </div>
              }
              @if (datos?.data?.direccion) {
                <div class="isla-dato">
                  <div>Dirección:</div>
                  <div [tooltip]="datos?.data?.direccion">
                    {{ datos?.data?.direccion }}
                  </div>
                </div>
              }
              @if (datos?.data?.victima) {
                <div class="isla-dato">
                  <div>Víctima:</div>
                  <div>{{ datos?.data?.victima }}</div>
                </div>
              }
              @if (datos?.data?.causante) {
                <div class="isla-dato">
                  <div>Causante:</div>
                  <div>{{ datos?.data?.causante }}</div>
                </div>
              }
              @if (datos?.data?.observaciones) {
                <div class="isla-dato">
                  <div>Observaciones:</div>
                  <div>{{ datos?.data?.observaciones }}</div>
                </div>
              }
              @if (datos?.data?.tags?.length) {
                <div class="isla-dato">
                  <div>Tags:</div>
                  <div>{{ datos?.data?.tags?.join(', ') }}</div>
                </div>
              }
            }
          }
          @case ('alertaSeguridad') {
            @if (datos?.data?.alerta) {
              <div class="isla-dato">
                <div>Estado:</div>
                <div>{{ datos?.data?.alerta?.estadoActual }}</div>
              </div>
              @if (datos?.data?.alerta?.fechaCreacion) {
                <div class="isla-dato">
                  <div>Fecha:</div>
                  <div>
                    {{
                      datos?.data?.alerta?.fechaCreacion
                        | date: 'dd/MM/yyyy HH:mm'
                    }}
                  </div>
                </div>
              }
              @if (datos?.data?.alerta?.tipo) {
                <div class="isla-dato">
                  <div>Tipo:</div>
                  <div>{{ datos?.data?.alerta?.tipo }}</div>
                </div>
              }
              @if (datos?.data?.alerta?.prioridad) {
                <div class="isla-dato">
                  <div>Prioridad:</div>
                  <div>{{ datos?.data?.alerta?.prioridad }}</div>
                </div>
              }
              @if (datos?.data?.alerta?.direccion) {
                <div class="isla-dato">
                  <div>Dirección:</div>
                  <div [tooltip]="datos?.data?.alerta?.direccion">
                    {{ datos?.data?.alerta?.direccion }}
                  </div>
                </div>
              }
              @if (datos?.data?.alerta?.configVecino?.datosPersonales?.nombre) {
                <div class="isla-dato">
                  <div>Vecino:</div>
                  <div>
                    {{
                      datos?.data?.alerta?.configVecino?.datosPersonales?.nombre
                    }}
                  </div>
                </div>
              }
              @if (fotoVecinoUrl; as fotoVecino) {
                <div class="isla-dato">
                  <div>Foto:</div>
                  <div>
                    <img
                      [src]="fotoVecino"
                      alt="Foto del vecino"
                      class="irx-clickeable foto-vecino-popup-avatar"
                      role="button"
                      tabindex="0"
                      (click)="mostrarVisorFotoVecino = true"
                      (keydown.enter)="mostrarVisorFotoVecino = true"
                      tooltip="Ver foto completa"
                    />
                    <app-image-viewer
                      [imageUrl]="fotoVecino"
                      [isVisible]="mostrarVisorFotoVecino"
                      altText="Foto del vecino"
                      (closeViewer)="mostrarVisorFotoVecino = false"
                    ></app-image-viewer>
                  </div>
                </div>
              }
              @if (datos?.data?.alerta?.boton?.nombre) {
                <div class="isla-dato">
                  <div>Botón:</div>
                  <div>{{ datos?.data?.alerta?.boton?.nombre }}</div>
                </div>
              }
            } @else if (datos?.data) {
              <div class="isla-dato">
                <div>Estado:</div>
                <div>{{ datos?.data?.estadoActual }}</div>
              </div>
              @if (datos?.data?.fechaCreacion) {
                <div class="isla-dato">
                  <div>Fecha:</div>
                  <div>
                    {{ datos?.data?.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                </div>
              }
            }
          }

          @default {
            @if (esGenerico && datos?.data) {
              <div class="datos-container">
                @if (datos.tipo) {
                  <div class="dato-item tipo-item">
                    <div>Tipo:</div>
                    <div>{{ datos.tipo }}</div>
                  </div>
                }
              </div>
            }
          }
        }
      </mat-card-content>

      <!-- Botones de acción fijos en la parte inferior -->
      <!-- (tipo === 'alarma' ||
        tipo === 'activo' ||
        tipo === 'colectivo' ||
        tipo === 'luminaria') && -->
      @if (datos?.data) {
        <mat-card-actions class="alarma-acciones">
          @if (puedeEditar) {
            <button irxBoton="secundario" (click)="editar()">
              <mat-icon>edit</mat-icon>
              Editar
            </button>
          }

          @if (tipo !== 'eventoSeguridad') {
            @if (tipo === 'alertaSeguridad' && alertaActiva()) {
              <button irxBoton="principal" (click)="verDetalles()">
                <mat-icon>troubleshoot</mat-icon>
                Atender
              </button>
            } @else {
              <button irxBoton="principal" (click)="verDetalles()">
                <mat-icon>info</mat-icon>
                Detalles
              </button>
            }
          }
        </mat-card-actions>
      }
    </mat-card>
  </div>
  <div class="popup-tip"></div>
}
